import { FC, memo } from 'react'
// import { Box } from '@chakra-ui/react'
import { createIcon } from '@chakra-ui/icons'

import { CustomIconProps } from 'types'
import CustomIcon from '../../CustomIcon'

const FolderCursorOutline = createIcon({
  displayName: 'FolderCursorOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        d="M21,11V8a2,2,0,0,0-2-2H12.04083L10.595,3.875A2,2,0,0,0,8.94142,3H5A2,2,0,0,0,3,5V17a2,2,0,0,0,2,2H8"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M14,15.99976l-.58544-.58548a1.4144,1.4144,0,0,0-2.00027,0h0a1.41437,1.41437,0,0,0-.17675,1.78462l1.94,2.91038A2.00007,2.00007,0,0,0,14.8418,21h3.79608a2,2,0,0,0,1.98455-1.752l.362-2.89685a2,2,0,0,0-1.66266-2.22186L17,13.75067V11.5A1.5,1.5,0,0,0,15.5,10h0A1.5,1.5,0,0,0,14,11.5Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path d="M0,24H24V0H0Z" fill="none" />
    </>
  ),
})

const FolderCursor: FC<CustomIconProps> = (props) => {
  // if (props.variant === 'twoTone') return <CustomIcon as={FolderCursorTwoTone} {...props} />

  return <CustomIcon as={FolderCursorOutline} {...props} />
}

export default memo(FolderCursor)
